import { Application, Partner, Program, User } from '@bybeam/platform-types';
import { formatCurrency, formatIfPhone } from '@platform-ui-common/utilities/format.js';
import { PlaceholderSource } from '@platform-ui-common/utilities/placeholder.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import useApplication from './contexts/useApplication.js';
import usePartner from './contexts/usePartner.js';
import useProgram from './contexts/useProgram.js';

interface PlaceholderParams {
  partner?: Partner;
  program?: Program;
  user?: User;
  application?: Application;
}

export default function usePlaceholder(): PlaceholderSource {
  const auth = useAuth();
  const partner = usePartner();
  const program = useProgram();
  const application = useApplication();

  return generatePlaceholders({ application, partner, program, user: auth?.user?.core });
}

export function generatePlaceholders({
  application,
  partner,
  program,
  user,
}: PlaceholderParams): PlaceholderSource {
  return {
    PARTNER_NAME: partner?.name,
    PROGRAM_NAME: program?.name,
    PARTNER_EMAIL: partner?.email,
    PARTNER_PHONE: formatIfPhone(partner?.phone),
    APPROVED_AMOUNT: application?.case?.fulfillments[0]
      ? formatCurrency(application?.case?.fulfillments[0]?.approvedAmount, true)
      : 'N/A',
    MAX_AMOUNT: program?.config?.maxFundingAmount
      ? formatCurrency(program?.config?.maxFundingAmount, false)
      : 'N/A',
    APPLICANT_NAME: application?.submitter?.name ?? user?.name,
    APPLICANT_EMAIL: application?.submitter?.email ?? user?.email,
    FAQ_PAGE: 'https://bybeam.zendesk.com/',
  };
}
